/** Checks if the current user has access to download asset **/

import type { Track } from '$lib/models/track';
import type { User } from '$lib/models/user';
import { AssetType } from './asset';

export function canDownload(asset: Track, user: User | null | void): boolean {
  return canDownloadType(asset.type, user);
}

export function canDownloadType(type: AssetType, user: User | null | void): boolean {
  if (user?.subscription.hasIntrosAccess && type === AssetType.Intro) {
    return true;
  }
  if (user?.subscription.hasSfxAccess && type === AssetType.SFX) {
    return true;
  }
  if (user?.subscription.hasTracksAccess && (type === AssetType.Track || type === AssetType.Version)) {
    return true;
  }
  if (user?.subscription.hasShortsAccess && type === AssetType.Short) {
    return true;
  }
  return false;
}

